module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_3.8877c904.png";